const skillGroups = {
  'Languages': ['JavaScript', 'TypeScript', 'Python', 'Groovy', 'SQL', 'Bash'],
  'Frameworks & Web Development': ['React', 'Preact', 'Next.js', 'Node.js', 'GraphQL', 'REST APIs', 'Sass', 'Tailwind', 'PostgreSQL', 'HTML5', 'CSS3', 'Cypress', 'Webpack', 'Vite'],
  'Tools & Platforms': ['VS Code', 'Docker', 'Postman', 'Jira', 'Notion', 'Stripe', 'CI/CD', 'Git', 'GitHub', 'AWS', 'Firebase', 'Figma', 'Claude', 'Copilot', 'Shopify', 'Magento', 'BigCommerce', 'Netlify', 'Render', 'Asana', 'Zendesk', 'Cyberduck', 'Athos Commerce', 'SmugMug API'],
};

export default skillGroups;
